export enum BranchTargetKind {
  NextQuestion = 'next',
  BranchChild = 'child',
}

export enum BranchRuleKind {
  Choice = 'choice',
  Boolean = 'boolean',
  Rating = 'rating',
  Matrix = 'matrix',
}

export enum RatingOperator {
  GreaterThan = '>',
  LessThan = '<',
  GreaterOrEqual = '>=',
  LessOrEqual = '<=',
  Equal = '=',
  NotEqual = '<>',
}
